// src/components/AdminHeader.js
import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { onAuthStateChanged, signOut } from "firebase/auth";
import { auth } from "../firebase";
import tchHeaderLogo from "../assets/tch-header-logo.png";

const AdminHeader = () => {
  const navigate = useNavigate();
  const [adminName, setAdminName] = useState("");
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, (user) => {
      if (user) {
        const name = user.displayName || user.email?.split("@")[0] || "Admin";
        setAdminName(name);
      } else {
        setAdminName("");
      }
    });

    return () => unsub();
  }, []);

  const handleLogout = async () => {
    await signOut(auth);
    localStorage.removeItem("adminToken");
    navigate("/admin");
  };

  return (
    <header className="bg-[#b4642d] text-white border-b border-[#f0c96a] shadow-md">
      <div className="max-w-7xl mx-auto px-4 py-3 flex items-center justify-between">

        {/* LOGO */}
        <div className="flex items-center gap-3">
          <img
            src={tchHeaderLogo}
            alt="Tender Castle Hostel"
            className="h-12 w-auto"
          />
        </div>

        {/* DESKTOP NAVIGATION */}
        <nav className="hidden md:flex gap-6 items-center text-sm font-medium">
          <NavLink to="/dashboard">Dashboard</NavLink>
          <NavLink to="/dashboard/rooms">Rooms</NavLink>
          <NavLink to="/dashboard/tenants">Tenants</NavLink>
          <NavLink to="/dashboard/payments">Payments</NavLink>
          <NavLink to="/dashboard/bookings">Bookings</NavLink>
          <NavLink to="/dashboard/users">Users</NavLink>

          <button
            onClick={handleLogout}
            className="bg-red-500 hover:bg-red-600 px-3 py-1 rounded text-sm"
          >
            Logout
          </button>
        </nav>

        {/* MOBILE HAMBURGER */}
        <button
          className="md:hidden text-white text-3xl"
          onClick={() => setMenuOpen(!menuOpen)}
        >
          ☰
        </button>
      </div>

      {/* MOBILE MENU */}
      {menuOpen && (
        <div className="md:hidden bg-[#c3753b] px-4 pb-4 space-y-3 text-sm">
          <NavLink className="block" to="/dashboard" onClick={() => setMenuOpen(false)}>
            Dashboard
          </NavLink>
          <NavLink className="block" to="/dashboard/rooms" onClick={() => setMenuOpen(false)}>
            Rooms
          </NavLink>
          <NavLink className="block" to="/dashboard/tenants" onClick={() => setMenuOpen(false)}>
            Tenants
          </NavLink>
          <NavLink className="block" to="/dashboard/payments" onClick={() => setMenuOpen(false)}>
            Payments
          </NavLink>
          <NavLink className="block" to="/dashboard/bookings" onClick={() => setMenuOpen(false)}>
            Bookings
          </NavLink>
          <NavLink className="block" to="/dashboard/users" onClick={() => setMenuOpen(false)}>
            Users
          </NavLink>

          <button
            onClick={handleLogout}
            className="block w-full bg-red-500 hover:bg-red-600 text-left px-3 py-2 rounded"
          >
            Logout
          </button>

          {adminName && (
            <p className="text-xs pt-2 opacity-90">Welcome, {adminName}</p>
          )}
        </div>
      )}
    </header>
  );
};

export default AdminHeader;
